import React, { useState, useEffect } from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import styles from '../../styles/forms/edit_my_company_member_employment_time_off_group_wizard/EditMyCompanyMemberEmploymentTimeOffGroupForm.scss';
import Button from '../../components/Button';
import { __, setTableParams } from '../../core/utils';
import { withRouter } from 'react-router';
import { subscribe } from 'react-contextual/dist/react-contextual.es';
import Localization from '../../helpers/Localization';
import Select from '../../components/Select';
import * as _ from 'lodash';
import Input from '../../components/Input';
import { connect } from 'react-redux';
import { map } from 'lodash';
import DateTimePicker from '../../components/DateTimePicker';

const EditMyCompanyMemberEmploymentTimeOffFutureGroupForm = ({
  handleSubmit,
  submitting,
  localization,
}) => {
  return (
    <Form onSubmit={handleSubmit} className={styles.wrapper}>
      <div className={styles.form}>
        <div className={styles.flex}>
          <div className={styles.f1}>
            <Field
              name='vacation_days_base'
              component={Input}
              label={__('table.columns.vacation_days_base')}
            />
          </div>
          <div className={styles.f1}>
            <Field
              name='minutes_off_base'
              component={Input}
              label={__('table.columns.max_compensatory_days')}
            />
          </div>
          <div className={styles.f1}>
            <Field
              disabled
              name='last_year_vacation_days'
              component={Input}
              label={__('table.columns.last_year_vacation_days')}
            />
          </div>
        </div>

        <div className={styles.flex}>
          <div className={styles.f1}>
            <Field
              disabled
              name='used_vacation_days'
              component={Input}
              label={__('table.columns.used_vacation_days')}
            />
          </div>
          <div className={styles.f1}>
            <Field
              disabled
              name='used_minutes_off'
              component={Input}
              label={__('table.columns.compensatory_days_used')}
            />
          </div>
          <div className={styles.f1}>
            <Field
              disabled
              name='vacation_days_remaining'
              component={Input}
              label={__('table.columns.vacation_days_remaining')}
            />
          </div>
        </div>

        <div className={styles.flex}>
          <div className={styles.f1}>
            <Field
              disabled
              name='available_compensatory_hours'
              component={Input}
              label={__('table.columns.available_compensatory_hours')}
            />
          </div>

          <div className={styles.f1}>
            <Field
              name='time_off_start_date'
              component={DateTimePicker}
              label={__('my_company_members.flyout.time_off_start_date')}
              footer
            />
          </div>
          <div className={styles.f1}>
            <Field
              name='time_off_end_date'
              component={DateTimePicker}
              label={__('my_company_members.flyout.time_off_end_date')}
              footer
            />
          </div>
        </div>
      </div>

      <div className={styles.footer}>
        <Button
          lightGray
          medium
          left
          middleText={__('button.cancel')}
          onClick={() =>
            setTableParams('my_company_members', {
              edit_my_company_member_employment_time_off_group_wizard:
                undefined,
            })
          }
        />
        <Button
          lightBlue
          medium
          right
          submit
          middleText={__('button.edit')}
          spinning={submitting}
        />
      </div>
    </Form>
  );
};

const mapStateToProps = (state) => {
  return {
    store: _.get(state.table, 'my_company_members'),
  };
};

export default withRouter(
  reduxForm({
    form: 'edit_my_company_member_employment_time_off_group_wizard.edit_my_company_member_employment_time_off_future_group',
  })(
    connect(
      mapStateToProps,
      null
    )(
      subscribe(
        Localization,
        'localization'
      )(EditMyCompanyMemberEmploymentTimeOffFutureGroupForm)
    )
  )
);
